export default __webpack_public_path__ + "static/mes-ff5871e0e536c4b67c38ead46687f2c0.png";